import React from 'react';
import { createStackNavigator } from '@react-navigation/stack';
import { ForgotPasswordScreen, CreatePasswordScreen } from './Forgot';
import NavOptions from '../constants/NavOptions';

const Stack = createStackNavigator();

const ForgotStack = ({ navigation, route }) => {

  return (
    <Stack.Navigator initialRouteName='ForgotPassword' screenOptions={NavOptions.all}>
      <Stack.Screen
        name='ForgotPassword'
        component={ForgotPasswordScreen}
        options={{ title: 'Forgot Password' }}
      />
      <Stack.Screen
        name='CreatePassword'
        component={CreatePasswordScreen}
        options={{ title: 'Create Password' }}
      />
    </Stack.Navigator>
  )

}

export default ForgotStack;